import AllDrugsVocabulary from "./AllDrugsVocabulary";

export default AllDrugsVocabulary;